import script from "./SongUploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SongUploadModal.vue?vue&type=script&setup=true&lang=js"

import "./SongUploadModal.vue?vue&type=style&index=0&id=6adb68ae&scoped=true&lang=css"
script.__scopeId = "data-v-6adb68ae"

export default script